<template>
  <div>
    <el-form
      ref="form"
      v-if="canUpdate()"
      class="full-form"
      :model="form"
      :rules="rules">
        <el-row :gutter="20">
          <el-col :sm="24" :md="8">
           <el-form-item prop="deductible">
              <el-autocomplete
                v-model="form.deductible"
                :fetch-suggestions="querySearch"
                placeholder="Seleccione el deducible"
                valueKey="name"
                @select="handleSelect"
              ></el-autocomplete>
           </el-form-item>
          </el-col>
          <el-col class="line text-center hidden-md-and-down"  :md="2">-</el-col>
          <el-col  :sm="24" :md="8">
            <el-form-item prop="percentage">
              <el-input-number  controls-position="right" :min="1" :max="100" v-model="form.percentage"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="6">
            <el-button type="success" class="btn-block" @click="save()" >+</el-button>
          </el-col>
        </el-row>
      <div role="alert" v-if="error.message" class="el-alert el-alert--error">
        <div class="el-alert__content">
          <span class="el-alert__title is-bold">{{ error.message }}</span>
          <p class="el-alert__description">
          <ul>
            <li v-for="item in error.errors">{{ item[0] }}</li>
          </ul>
          </p>
        </div>
      </div>
    </el-form>
    <app-table
      class="mt-2"
      @change-pagination="onChangePagination"
      :total="total"
      :disable_search="true">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop="deductible.name"
          label="Deducible">
        </el-table-column>
        <el-table-column
          prop="percentage"
          label="Porcentaje">
        </el-table-column>
        <el-table-column
          v-if="canUpdate()"
          :width ="100"
          label="Acciones">
          <template slot-scope="scope">
            <el-button
              v-if="canUpdate()"
              size="mini"
              type="warning"
              @click="showDialog(scope.row)"><i class="el-icon-edit"></i></el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"><i class="el-icon-delete"></i></el-button>
          </template>
        </el-table-column>
      </el-table>
    </app-table>
  </div>
</template>
<script>
  import AppTable from '../../components/Table'
  import {baseApi} from '../../configs/urls'
  import BaseCrud from '../../components/abstract/BaseCrud'
  import {parseError} from '../../packages/Helpers'
  export default {
    extends: BaseCrud,
    name: 'company-list',
    props: ['company_id'],
    components: {
      AppTable
    },
    data () {
      return {
        baseUrl: baseApi + `/deductiblesbycompany/${this.company_id}`,
        form: {
        },
        state1: '',
        deductibles: [],
        provisions: [],
        activeName: 'first',
        dialogTitle: 'Agregar Empresa',
        basePermission: 'companies',
        rules: {
          deductible_id: [{ required: true, message: 'El deducible es requerido', trigger: 'blur' }],
          percentage: [{required: true, message: 'El porcentaje es requerido'},
            {type: 'number', message: 'El porcentaje debe ser un numero'}]
        }
      }
    },
    watch: {
      company_id: function () {
        this.loadAll()
      }
    },
    methods: {
      successAction () {
        this.$refs.form.resetFields()
        this.refreshData()
        this.processing = false

        this.success = true
        setTimeout(() => {
          this.success = false
        }, 3000)
      },
      save () {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.processing = true
            this.error = {}
            let data = Object.assign({}, this.form)
            data = this._beforeSend(data)
            console.log(data)

            if (!this.form.id) {
              this.$http.post(this.baseUrl, data, this.params)
                .then(
                  () => {
                    this.successAction()
                  },
                  (res) => {
                    this.showErrors(res)
                  }
                )
            } else {
              this.$http[this.methodForUpdate](this.baseUrl, data, this.params)
                .then(
                  () => {
                    this.successAction()
                  },
                  (res) => {
                    this.showErrors(res)
                  }
                )
            }
          } else {
            return false
          }
        })
      },
      _formatModel (model) {
        if (typeof (model.deductible) === 'object') {
          model.deductible = model.deductible.name
        }
      },
      querySearch (queryString, cb) {
        var links = this.deductibles
        var results = queryString ? links.filter(this.createFilter(queryString)) : links
        // call callback function to return suggestions
        cb(results)
      },
      createFilter (queryString) {
        return (item) => {
          return (item.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
      },
      loadAll () {
        this.baseUrl = baseApi + `/deductiblesbycompany/${this.company_id}`
        this.refreshData()
        this.$http.get(baseApi + '/deductibles')
          .then(
            (res) => {
              this.deductibles = res.body
            }
          )
      },
      handleSelect (item) {
        this.form.deductible_id = item.id
      },
      _mounted () {
        this.loadAll()
      },
      _getDeleteTitle (model) {
        return 'Esta seguro que desea elimnar ' + model.deductible.name
      },
      handleDelete (index, row) {
        this.$confirm(this._getDeleteTitle(row), 'Advertencia', {
          confirmButtonText: 'Si',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }).then(() => {
          this.loading = true
          this.$http.delete(baseApi + '/deductiblesbycompany/' + row.id)
            .then(
              () => {
                this.$message({
                  type: 'success',
                  message: 'Eliminado correctamente.'
                })
                this.tableData = this.tableData.filter((item) => {
                  return item.id !== row.id
                })
                this.loading = false
              },
              (res) => {
                this.$message.error(parseError(res)[0])
                this.loading = false
              }
            )
        })
      }
    }
  }
</script>
<style>
  .float-left{
    float: right;
  }
  .text-center{
    text-align: center;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/views/companies/DeductiblesTable.vue